import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistCtx = createContext(null);
export const useWishlist = () => useContext(WishlistCtx);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setItems([]); return; }
    try {
      const { data } = await client.get("/wishlist");
      setItems(data);
    } catch { setItems([]); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const has = (product_id, size = null) =>
    items.some(i => i.product_id === product_id && (size == null || i.size === size));

  const add = async (product_id, size = null, notify_restock = true) => {
    const { data } = await client.post("/wishlist", { product_id, size, notify_restock });
    setItems(data);
  };
  const remove = async (product_id, size = null) => {
    const url = size ? `/wishlist/${product_id}?size=${encodeURIComponent(size)}` : `/wishlist/${product_id}`;
    const { data } = await client.delete(url);
    setItems(data);
  };
  const toggle = async (product_id, size = null) => {
    if (has(product_id, size)) await remove(product_id, size);
    else await add(product_id, size, true);
  };

  return (
    <WishlistCtx.Provider value={{ items, has, add, remove, toggle, refresh, count: items.length }}>
      {children}
    </WishlistCtx.Provider>
  );
}
